import { useIntl } from 'react-intl';
import { Col, Row, Select } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import {
  MaterialReturnListRequest,
  ReturnMaterialType,
} from '@/core/domain/stock/MaterialReturn/MaterialReturn.types';
import { FloatingFormItem } from '@/components/_common';

function ReturnMaterialFilterType({
  setQueryParams,
  queryParams,
}: ExtraFiltersProps<MaterialReturnListRequest>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem label="Tipo">
          <Select
            value={queryParams?.type}
            options={[
              {
                value: ReturnMaterialType.part,
                label: intl.formatMessage({
                  id: 'deliveryOrReturnOfMaterials.returnMaterial.form.display.part',
                }),
              },
              {
                value: ReturnMaterialType.consumable,
                label: intl.formatMessage({
                  id: 'deliveryOrReturnOfMaterials.returnMaterial.form.display.consumable',
                }),
              },
            ]}
            onChange={(value) =>
              setQueryParams((prev) => ({
                ...prev,
                type: value,
              }))
            }
          />
        </FloatingFormItem>
      </Col>
    </Row>
  );
}

export default ReturnMaterialFilterType;
